import { getConfig, getInterceptors } from '@goparrot-dashboard-api/shared';
import { TemplateFacade } from '@goparrot/campaign-sdk';

export const campaignTemplateFacade = new TemplateFacade(getConfig('campaign'), getInterceptors() as unknown);
